@let detailsFormValue = detailsForm();
@let showSalutationFieldsValue = showSalutationFields();
@let showAddTitlesButtonValue = showAddTitlesButton();
@let generalTitleOptionsWithCannyLinkValue = generalTitleOptionsWithCannyLink();
@let professionalTitleOptionsWithCannyLinkValue = professionalTitleOptionsWithCannyLink();
@let autoFocusOnNameValue = autoFocusOnName();

<div layout-full-width>
  <form [formGroup]="detailsFormValue">
    @if (showSalutationFieldsValue) {
      <div layout-horizontal layout-justify-flex-end layout-align-items-end>
        <div class="salutation-fields-container" layout-full-width>
          <rt-form-field margin-right-small margin-bottom-small>
            @let generalTitleLabel =
              'app.candidate.edit_candidate_personal_details.general_title' | translate;
            <rt-label>
              <span
                [rtTooltip]="generalTitleLabel"
                [rtTooltipEnableWhenTruncated]="true"
                class="label"
              >
                {{ generalTitleLabel }}
              </span>
            </rt-label>

            <rt-select
              formControlName="salutation"
              [options]="generalTitleOptionsWithCannyLinkValue"
              [includeEmptyOption]="false"
              [hasInputTrigger]="true"
              [optionTemplate]="generalTitleOptionTemplate"
              [placeholder]="'app.common.select' | translate"
              [hasSearch]="false"
              [rtProtectedControl]="detailsFormValue.controls.salutation"
              [rtProtectedControlName]="'detailsForm.salutation'"
            >
              <ng-template #generalTitleOptionTemplate let-option="option">
                <ng-container
                  *ngTemplateOutlet="
                    selectItemTemplate;
                    context: {
                      option: option,
                      isSelected: detailsFormValue.controls.salutation.value === option.value,
                    }
                  "
                />
              </ng-template>
            </rt-select>
          </rt-form-field>

          <rt-form-field margin-right-small margin-bottom-small>
            @let professionalTitleLabel =
              'app.candidate.edit_candidate_personal_details.professional_title' | translate;
            <rt-label>
              <span
                [rtTooltip]="professionalTitleLabel"
                [rtTooltipEnableWhenTruncated]="true"
                class="label"
              >
                {{ professionalTitleLabel }}
              </span>
            </rt-label>

            <rt-select
              formControlName="title"
              [options]="professionalTitleOptionsWithCannyLinkValue"
              [includeEmptyOption]="false"
              [hasInputTrigger]="true"
              [optionTemplate]="professionalTitleOptionTemplate"
              [placeholder]="'app.common.select' | translate"
              [hasSearch]="false"
              [itemTextNoPadding]="true"
              [rtProtectedControl]="detailsFormValue.controls.title"
              [rtProtectedControlName]="'detailsForm.title'"
            >
              <ng-template #professionalTitleOptionTemplate let-option="option">
                <ng-container
                  *ngTemplateOutlet="
                    selectItemTemplate;
                    context: {
                      option: option,
                      isSelected: detailsFormValue.controls.title.value === option.value,
                    }
                  "
                />
              </ng-template>
            </rt-select>
          </rt-form-field>
        </div>

        <rt-icon-button
          variant="plain"
          iconName="expand-less"
          [rtTooltip]="'app.candidate.edit_candidate_personal_details.hide_titles' | translate"
          (click)="hideSalutationFields()"
          margin-bottom-small
        />
      </div>
    }

    <rt-form-field [hideRequiredBadge]="true">
      <div layout layout-align-items-center layout-space-between margin-bottom-small-xx>
        <rt-label [hasRequiredBadge]="detailsFormValue.controls.name.invalid">
          {{ 'app.candidate.edit_candidate_personal_details.full_name' | translate }}
        </rt-label>

        @if (showAddTitlesButtonValue) {
          <rt-button
            variant="plain"
            size="small"
            [rtWalkthroughOriginStepId]="'walkthrough-step-salutation-field-3'"
            (click)="addSalutationFields()"
          >
            {{ 'app.candidate.edit_candidate_personal_details.edit_titles' | translate }}
          </rt-button>
        }
      </div>

      <rt-input
        variant="rounded"
        type="text"
        formControlName="name"
        [autoFocus]="autoFocusOnNameValue"
        [placeholder]="'app.candidate.edit_candidate_personal_details.type_name' | translate"
        [rtProtectedControl]="detailsFormValue.controls.name"
        [rtProtectedControlName]="'detailsForm.name'"
      />
    </rt-form-field>
  </form>
</div>

<ng-template #selectItemTemplate let-option="option" let-isSelected="isSelected">
  @if (option.value !== 'missing_link') {
    <div class="title-option">
      {{ option.label }}
      @if (isSelected) {
        <rt-icon [name]="'check'" [colorToken]="'colorIconSuccessDefault'" />
      }
    </div>
  } @else {
    <div
      (click)="$event.preventDefault(); $event.stopPropagation(); openCanny()"
      class="title-option missing-title"
    >
      <span [rtTooltip]="option.label" [rtTooltipEnableWhenTruncated]="true" class="text">{{
        option.label
      }}</span>
      <rt-icon [name]="'open-in-new'" />
    </div>
  }
</ng-template>
